import { X } from 'lucide-react'
import clsx from 'clsx'

interface AlertProps {
  type?: 'success' | 'error' | 'warning' | 'info'
  message: string | React.ReactNode
  onClose?: () => void
}

export default function Alert({ type = 'info', message, onClose }: AlertProps) {
  const typeClasses = {
    success: 'bg-green-50 text-green-800 border-green-200',
    error: 'bg-red-50 text-red-800 border-red-200',
    warning: 'bg-yellow-50 text-yellow-800 border-yellow-200',
    info: 'bg-blue-50 text-blue-800 border-blue-200',
  }

  return (
    <div className={clsx('p-4 rounded-lg border', typeClasses[type])}>
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium">{message}</p>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-4 text-current hover:opacity-75 focus:outline-none"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  )
}
